/**** Open Cart Drawer Function ****/
function openCartDrawer() {
    $('.cart_drawer').addClass('active');
    $('body').addClass('overflow-hidden');
}

/**** Close Cart Drawer Function ****/
function closeCartDrawer() {
    $('.cart_drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
}

/**** Update Single Item Quantity Function ****/
function updateQuantity(lineItemKey, quantity, input, sections) {
  let formData = {
    'id': lineItemKey,
    'quantity': quantity,
  };
  if (!sections) {
    formData.sections = getSectionsToRender().map((section) => section.section);
  }
     
  fetch('/cart/change.js?item_quantity_update', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    if(responseJson.description) {
      if(input) input.val(quantity - 1);
      // showNotification(window.notificationErrorTemplate(responseJson.description));
      updateHeaderCartCount();
      return;
    }
    updateHeaderCartCount();
    console.log("responseJson ",responseJson);
    updateCartDrawer(responseJson);
  })
 
}

/**** Update Cart Count Function ****/
function updateHeaderCartCount() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      $('.cart-item-count').text(cart.item_count);

      if (cart.item_count > 0) {
        $('.header-tools-cart').addClass('cart-has-content');
      } else {
        $('.header-tools-cart').removeClass('cart-has-content');
      }
    })
    .catch(err => {
      console.error('Cart count update failed:', err);
    });
}

/**** Update Cart Drawer HTML Function ****/
// function updateCartDrawer(response) {
//   if (!response) return;
//   var cart_drawer_html = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
//   var sourceElement = cart_drawer_html.querySelector('#CartDrawer');

//   // var itemCount = sourceElement.querySelector('.cart-drawer-content').getAttribute('data-item-count');
  
//   var getSections_Render = getSectionsToRender();
//   $.each(getSections_Render, function(key, section) {
   
//     const elementToReplace = $('#'+section.id).find(section.selector) || $('#'+section.id);
//     if(elementToReplace.length > 0) {
//       elementToReplace.html(getSectionInnerHTML(response.sections[section.section], section.selector))
//     }
//   });
// }
function updateCartDrawer(response) {
  if (!response || !response.sections) return;

  const sections = getSectionsToRender();

  sections.forEach(section => {
    const html = response.sections[section.section];
    if (!html) return;

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newContent = parsedHTML.querySelector(section.selector);

    if (!newContent) return;

    const target =
      document.querySelector(`#${section.id} ${section.selector}`) ||
      document.querySelector(`#${section.id}`);

    if (target) {
      target.innerHTML = newContent.innerHTML;
    }
  });
}


/**** Get HTML Functions ****/
function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

function getSectionsToRender() {
  return [
    {
      id: 'CartDrawer',
      section: 'cart-drawer',
      selector: '.cart-drawer-form-wrapper',
    },
  ];
}
//  function getSectionsToRender() {
//   debugger
//     return [
//       {
//         id: 'cart-drawer',
//         selector: '#CartDrawer',
//       },
//       {
//         id: 'cart-icon--bubble',
//       },
//     ];
//   }



$(document).ready(function (){
    /**** Mini Drawer on plus and minus click quantity update ****/
   $(document)
  .off("click", ".quantity-down.minus, .plus.quantity-up")
  .on("click", ".quantity-down.minus, .plus.quantity-up", function (e) {
    e.preventDefault();

    var input = $(this).closest(".quantity").find(".cart-item__quantity-input");
    var oldVal = parseInt(input.val()) || 0;
    var newVal = oldVal;

    if ($(this).attr("data-name") === "plus") {
      newVal = oldVal + 1;
    } else {
      newVal = Math.max(0, oldVal - 1);
    }

    input.val(newVal);

    var line_item_key = $(this).closest(".cart-item").attr("data-key");
    updateQuantity(line_item_key, newVal, input);

  });

    /**** Mini Drawer on remove button click item remove ****/
    $(document).on("click", ".cart-item__remove", function (e) {
        e.preventDefault();
        $(this).addClass('loading__spinner');
        var line_item_key = $(this).parents('.cart-item').attr('data-key');
        updateQuantity(line_item_key, 0);
    });

    /***** Open cart drawer */
    $(document).on("click", "#cart-icon--bubble", function () {
      openCartDrawer();
    });

    /***** Close cart drawer */  
    $(document).on("click", ".drawer__close, .cart-drawer__overlay", function () {
      closeCartDrawer();
    });
    
    // When "Add to Cart" button is clicked
    // $(document).on("click", ".product-form .add-to-cart", function (e) {
    //   e.preventDefault();

    //   let $btn = $(this);
    //   let $form = $btn.closest(".product-form");

    //   let defaultText = $btn.text();
    //   $btn.text("Adding...").prop("disabled", true);

    //   let variantID = parseInt($form.find('input[name="id"]').val() || $form.find('select[name="id"]').val() || 0);

    //   let qty = parseInt($form.find('input[name="quantity"]').val()) || 1;

    //   if (!variantID) {
    //       alert("Please select a product variant.");
    //       $btn.text(defaultText).prop("disabled", false);
    //       return;
    //   }

    //   let items = [{ id: variantID, quantity: qty }];

    //   fetch('/cart/add.js?product_add_to_cart', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify({ items, sections: getSectionsToRender().map(s => s.section) })
    //   })
    //   .then(res => res.json())
    //   .then(data => {
    //       if (data.description) { 
    //           showNotification(window.notificationErrorTemplate(data.description));
    //       } else {
    //           updateCartDrawer(data); 
    //           openCartDrawer(); 
    //       }
    //       $btn.text(defaultText).prop("disabled", false);
    //   })
    //   .catch(err => {
    //       console.error("Add to cart error:", err);
    //       $btn.text(defaultText).prop("disabled", false);
    //   });
    // });

    // ================ upsell Add to car code Start =================== 
    // $(document).on("click", ".cart-upsell-btn,.cart-routine-btn", function (e) {
    //   e.preventDefault();

    //   let $btn = $(this);
    //   let defaultText = $btn;
    //   $btn.addClass("Adding").prop("disabled", true);

    //   let variantID = parseInt($btn.val());
    //   if (!variantID) {
    //       console.error("Variant ID not found!");
    //       $btn.text(defaultText).prop("disabled", false);
    //       return;
    //   }

    //   let items = [{ id: variantID, quantity: 1 }];

    //   fetch('/cart/add.js?product_add_to_cart', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify({
    //           items,
    //           sections: getSectionsToRender().map(s => s.section)
    //       })
    //   })
    //   .then(res => res.json())
    //   .then(data => {
    //       if (data.status && data.status !== 200) {
    //           console.error("Error:", data.description);
    //           alert(data.description);
    //       } else {
    //           updateCartDrawer(data);
    //       }
    //       $btn.removeClass("Adding").prop("disabled", true);
    //   })
    //   .catch(err => {
    //       console.error("Upsell Add to Cart Error:", err);
    //       $btn.removeClass("Adding").prop("disabled", true);
    //   });
    // });
    function addItemToCart(variantID, $btn, qty, sellingPlanId = null) {
        if (!variantID) {
            console.error("Variant ID not found!");
            if ($btn) $btn.removeClass("Adding").prop("disabled", false);
            return;
        }

        // let items = [{ id: parseInt(variantID), quantity: qty }];
          let item = {
            id: parseInt(variantID, 10),
            quantity: qty
          };

        
        // ✅ Add selling plan ONLY if it exists
        if (sellingPlanId) {
            item.selling_plan = sellingPlanId;
        }

          const body = {
            items: [item],
            sections: getSectionsToRender().map(section => section.section)
          };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json' 
            },
            body: JSON.stringify(body)
        })
        .then(res => res.json())
        .then(data => {
            if (data.status && data.status !== 200) {
                console.error("Error:", data.description);
            } else {
                updateCartDrawer(data);
            }

            if ($btn) {
                $btn.removeClass("Adding").prop("disabled", true);
            }
        })
        .catch(err => {
            console.error("Add to Cart Error:", err);
            if ($btn) {
                $btn.removeClass("Adding").prop("disabled", true);
            }
        });
    }

    function removeCartItem(lineItemKey) {
      const sections = getSectionsToRender().map(s => s.section);

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0
        })
      })
      .then(() => {
        return fetch(`/cart?sections=${sections.join(',')}`);
      })
      .then(res => res.json())
      .then(sectionsHTML => {
        // 🔧 Wrap response to match updateCartDrawer expectation
        return {
          sections: sectionsHTML
        };
      });
    }



    $(document).on("click", ".cart-upsell-btn, .cart-routine-btn", function (e) {
      e.preventDefault();
      let sellingPlanId
      let $btn = $(this);
      $btn.addClass("Adding").prop("disabled", true);

      let variantID = $btn.val();
      let qty = 1;
      addItemToCart(variantID, $btn, qty);
    });

    $(document).on('click', '.cart-subscription-button', function () {
      var $btn = $(this);

      var lineItemKey = $btn.attr('data-line-item-key');
      var variantID = $btn.attr('data-item-variant-id');
      var sellingPlanId = $btn.attr('data-selling-plan-id');
      var qty = $btn.attr('data-item-qty');
      var loader = $btn.closest('.cart-drawer-item').find('.cart-ajax-loader-text');

      if (!lineItemKey || !variantID || !sellingPlanId) {
        console.error('Missing required data');
        return;
      }
      loader.show();
      $btn.hide();
      removeCartItem(lineItemKey)
      .then(() => {
        return addItemToCart(variantID, $btn, qty, sellingPlanId);
      })
      .then(data => {
        updateCartDrawer(data);
      })
      .catch(err => {
        console.error('Failed to switch to subscription:', err);
      })

      .finally(() => {
      });
    });
});
